import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';

import { InfoTeaser } from '../../../shared/interfaces/info-teaser.interface';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { CaasComponent } from '../../../shared/interfaces/caas/caas.interface';
import { HrefType } from '../../../shared/enums/href-type.enums';
import { CaasBodytextService } from '../../../services/caas-bodytext.service';
import { CaasRoutesService } from '../../../services/caas-routes.service';

@Component({
  selector: 'hdi-info-teasers',
  standalone: true,
  imports: [IconComponent, CommonModule, RouterModule],
  templateUrl: './info-teasers.component.html',
  styleUrls: ['./info-teasers.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class InfoTeasersComponent implements OnChanges {
  @ViewChildren('text') text!: QueryList<ElementRef>;
  @Input() icon: string = 'envelope-open-text';
  @Input() infoTeasers: InfoTeaser[] = [];
  @Input() viewport?: ViewportType;
  @Input() caasData?: CaasComponent;
  @Input() numbering: boolean = false;

  public readonly Sizes = Sizes;
  public readonly Colors = Colors;
  public readonly HrefType = HrefType;

  constructor(
    private caasBodytextService: CaasBodytextService,
    private caasRoutesService: CaasRoutesService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['caasData'] &&
      this.caasData!.formData.st_items!.value.length > 0
    ) {
      this.numbering = this.caasData!.formData.st_number?.value ?? false;
      this.setCaasInfoTeasers();
    }
  }

  replaceTextWithLinks(teaserText: string, infoTeaser: InfoTeaser) {
    infoTeaser.links?.forEach((link) => {
      if (teaserText.includes(link.label)) {
        teaserText = teaserText.replace(
          link.label,
          `<a href="${link.href}" target="${link.target ?? '_self'}">${link.label}</a>`
        );
      }
    });
    return teaserText;
  }

  setCaasInfoTeasers() {
    this.infoTeasers = this.caasData!.formData.st_items!.value.map(
      (infoTeaser) => {
        const content = this.caasBodytextService.extractTextEditorContent(
          infoTeaser.formData.st_bodytext?.value ?? ''
        );

        return {
          icon: infoTeaser.formData.st_icon?.value as string,
          text: content!,
        };
      }
    );
  }
}
